/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2024 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

// Keep in sync with EnhanceSpeechTrack on backend
export const NATIVELY_ACCEPTED_AUDIO_FILE_TYPES = ".mp3,.wav";
export const ESV2_ACCEPT_AUDIO_FILE_TYPES =
  ".mp3,.wav,.aac,.flac,.oga,.ogg,.m4a";
export const ACCEPT_VIDEO_FILE_TYPES = ".mp4,.m4v,.mov,.3gpp,.3gp";

// Allow selecting both audio and video
export const ACCEPTED_FILE_TYPES = `${ESV2_ACCEPT_AUDIO_FILE_TYPES},${ACCEPT_VIDEO_FILE_TYPES}`;

export const NATIVELY_SUPPORTED_AUDIO_CONTENT_TYPES: string[] = [
  "audio/wav",
  "audio/x-wav",
  "audio/mpeg",
  "audio/mpeg3",
  "audio/x-mpeg-3",
] as const;

export const ACCEPTED_AUDIO_CONTENT_TYPES: string[] = [
  ...NATIVELY_SUPPORTED_AUDIO_CONTENT_TYPES,
  "audio/aac",
  "audio/flac",
  "audio/m4a",
  "audio/mp4",
  "audio/mpeg4-generic",
  "audio/ogg",
  "audio/opus",
  "audio/vnd.dlna.adts",
  "audio/vorbis",
  "audio/x-aac",
  "audio/x-aiff",
  "audio/x-flac",
  "audio/x-m4a",
] as const;

export const ACCEPTED_VIDEO_CONTENT_TYPES: string[] = [
  "video/mp4",
  "video/quicktime",
  "video/x-m4v",
  "video/3gpp",
] as const;

export const ACCEPTED_CONTENT_TYPES: string[] = [
  ...ACCEPTED_AUDIO_CONTENT_TYPES,
  ...ACCEPTED_VIDEO_CONTENT_TYPES,
] as const;
